"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _HeroDialog = _interopRequireDefault(require("../HeroDialog"));

var _FabButton = _interopRequireDefault(require("../Button/FabButton"));

var View = function View(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["open", "onClose", "children", "isLoading"]);
  return /*#__PURE__*/_react["default"].createElement(_HeroDialog["default"], (0, _extends2["default"])({}, props, {
    open: open,
    onClose: onClose
  }), !isLoading ? children : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center w-full h-full"
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 top-0 mt-8 mr-8"
  }, /*#__PURE__*/_react["default"].createElement(_FabButton["default"], {
    title: "Close",
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))));
};

View.displayName = 'SiftDetailModal';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=DetailModal.js.map